export default __webpack_public_path__ + "static/media/natgeo.d46427d6.png";